var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./Frame.module.scss";
import Header from "../Header/Header";
import { getSettings } from "../../constants/setting";
import { currentLanguage, isSurveyMinimized, languageCode, minimizeChat } from "../../stores/reducers/chatReducer";
import { useDispatch, useSelector } from "react-redux";
import { CHAT_BOT_POSITION_LEFT, getApiDomainFromElement } from "../../constants";
import { NavLink } from "react-bootstrap";
import SurveyHeader from "../SurveyHeader/SurveyHeader";
import { isEmpty } from "lodash";
var Frame = function (props) {
    var dispatch = useDispatch();
    var isMinimized = props.isMinimized, onClickMinimize = props.onClickMinimize;
    var isMinimizedSurvey = useSelector(isSurveyMinimized);
    var language = useSelector(currentLanguage);
    var _b = getSettings(), bot_id = _b.bot_id, app_domain = _b.app_domain, chat_bot_position = _b.chat_bot_position, icon_bottom_offset = _b.icon_bottom_offset, primary_color = _b.primary_color, window_radius = _b.window_radius, survey_primary_question = _b.survey_primary_question, enable_surveys = _b.enable_surveys;
    var _j = useState(), showContactForm = _j[0], setShowContactForm = _j[1];
    var onChangeLanguage = function (language) {
        dispatch(languageCode(language));
    };
    var alwaysonOpenChatbot = function (option) {
        if ((option === null || option === void 0 ? void 0 : option.showContactForm) !== undefined) {
            setShowContactForm(option === null || option === void 0 ? void 0 : option.showContactForm);
        }
        dispatch(minimizeChat(false));
    };
    useEffect(function () {
        // @ts-ignore
        window.alwaysonOpenChatbot = alwaysonOpenChatbot;
    }, []);
    var frameSrc = window.location.protocol + '//' + app_domain + '/chatbot/' + bot_id + "?language=" + language + '&api_domain=' + getApiDomainFromElement() + '&current_page_url=' + window.location.href;
    if (showContactForm) {
        frameSrc += '&show_contact_form=true';
        // @ts-ignore
        if (showContactForm === null || showContactForm === void 0 ? void 0 : showContactForm.topic) {
            // @ts-ignore
            frameSrc += '&contact_form_topic=' + (showContactForm === null || showContactForm === void 0 ? void 0 : showContactForm.topic);
        }
    }
    return _jsxs("div", __assign({}, { tabIndex: 0 }, { className: styles.alwaysonFrameContainer + ' ' + (!isMinimized ? styles.active : ''), style: {
            bottom: icon_bottom_offset || '30px',
            right: chat_bot_position === CHAT_BOT_POSITION_LEFT ? 'auto' : '30px',
            left: chat_bot_position === CHAT_BOT_POSITION_LEFT ? '30px' : 'auto',
            borderRadius: window_radius + 'px'
        } }, { children: [_jsx(Header, { onClickMinimize: onClickMinimize, onChangeLanguage: onChangeLanguage }), !isMinimizedSurvey && enable_surveys && !isEmpty(survey_primary_question) && _jsx(SurveyHeader, {}), _jsx("div", __assign({ className: styles.alwaysonFrameHolder }, { children: !isMinimized ?
                    _jsx("iframe", __assign({}, { tabIndex: 0 }, { src: frameSrc, className: styles.alwaysonFrameContent })) : null })), _jsx("div", __assign({ className: styles.frameFooter }, { children: _jsx(NavLink, __assign({}, { tabIndex: 0 }, { href: "https://alwayson.ai", target: "_blank", style: {
                        color: primary_color
                    } }, { children: "Powered by AlwaysOn" })) }))] }));
};
// @ts-ignore
export default Frame;
